export type ColorScale = { [shade: string]: string }

export const error: ColorScale = {
  50: '#fdeaee',
  100: '#f8bfc9',
  200: '#f5a0af',
  300: '#f0748b',
  400: '#ed5975',
  500: '#e93052',
  600: '#d42c4b',
  700: '#a5223a',
  800: '#801a2d',
  900: '#621422'
}

export const info: ColorScale = {
  50: '#ecf0fe',
  100: '#c5cffc',
  200: '#a9b8fb',
  300: '#8298f9',
  400: '#6a84f8',
  500: '#4565f6',
  600: '#3f5ce0',
  700: '#3148af',
  800: '#263887',
  900: '#1d2a67'
}

export const learn: ColorScale = {
  50: '#f9edfc',
  100: '#ecc8f5',
  200: '#e3adf1',
  300: '#d687ea',
  400: '#ce70e6',
  500: '#c24ce0',
  600: '#b145cc',
  700: '#8a369f',
  800: '#6b2a7b',
  900: '#51205e'
}

export const success: ColorScale = {
  50: '#ecfaf2',
  100: '#c4f0d7',
  200: '#a8e9c4',
  300: '#80dfa9',
  400: '#68d999',
  500: '#42cf7f',
  600: '#3cbc74',
  700: '#2f935a',
  800: '#247246',
  900: '#1c5735'
}

export const warning: ColorScale = {
  50: '#fef8ec',
  100: '#fce9c5',
  200: '#fadea9',
  300: '#f8cf81',
  400: '#f7c669',
  500: '#f5b843',
  600: '#dfa73d',
  700: '#ae8330',
  800: '#876525',
  900: '#6a3c05'
}

export const blueGrey: ColorScale = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  A100: '#cfd8dc',
  A200: '#b0bec5',
  A400: '#78909c',
  A700: '#455a64'
}

export const cyan: ColorScale = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00bcd4',
  600: '#00acc1',
  700: '#0097a7',
  800: '#00838f',
  900: '#006064',
  A100: '#84ffff',
  A200: '#18ffff',
  A400: '#00e5ff',
  A700: '#00b8d4'
}

export const deepOrange: ColorScale = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
  A100: '#ff9e80',
  A200: '#ff6e40',
  A400: '#ff3d00',
  A700: '#dd2c00'
}

export const deepPurple: ColorScale = {
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
}

export const green: ColorScale = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
}

export const grey: ColorScale = {
  0: '#ffffff',
  25: '#f9f9fc',
  50: '#f3f3f6',
  100: '#ebebee',
  200: '#dcdcdf',
  300: '#b8b8bc',
  400: '#99999c',
  500: '#707073',
  600: '#5d5d5f',
  700: '#3e3e40',
  800: '#1d1d20',
  900: '#161619',
  950: '#0f0f11',
  1000: '#000000',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161'
}

export const indigo: ColorScale = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
}

export const lightBlue: ColorScale = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
}

export const lightGreen: ColorScale = {
  50: '#f1f8e9',
  100: '#dcedc8',
  200: '#c5e1a5',
  300: '#aed581',
  400: '#8bc34a',
  500: '#8bc34a',
  600: '#7cb342',
  700: '#689f38',
  800: '#558b2f',
  900: '#33691e',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#76ff03',
  A700: '#64dd17'
}

export const lime: ColorScale = {
  50: '#f9fbe7',
  100: '#f0f4c3',
  200: '#e6ee9c',
  300: '#dce775',
  400: '#d4e157',
  500: '#cddc39',
  600: '#c0ca33',
  700: '#afb42b',
  800: '#9e9d24',
  900: '#827717',
  A100: '#f4ff81',
  A200: '#eeff41',
  A400: '#c6ff00',
  A700: '#aeea00'
}

export const orange: ColorScale = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
}

export const pink: ColorScale = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
}

export const red: ColorScale = {
  50: '#feebee',
  100: '#fecdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
}

export const teal: ColorScale = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
}

export const walttiBrightViolet: ColorScale = {
  50: '#ede8fe',
  100: '#d0c8f4',
  200: '#b0a4ed',
  300: '#8e7fe7',
  400: '#7263e1',
  500: '#6759cb',
  600: '#5b4fb4',
  700: '#564aa9',
  800: '#443b87',
  900: '#28234f'
}

export const walttiMidnight: ColorScale = {
  50: '#e5e5ed',
  100: '#bebdd2',
  200: '#9492b4',
  300: '#6c6a96',
  400: '#524c82',
  500: '#2b215d',
  600: '#241851',
  700: '#17083b',
  800: '#10062a',
  900: '#0d0420'
}

export const walttiOrange: ColorScale = {
  50: '#faeae9',
  100: '#fdcec1',
  200: '#fdae99',
  300: '#fd8f71',
  400: '#fe7653',
  500: '#fe5f37',
  600: '#f35933',
  700: '#e5532e',
  800: '#d93e17',
  900: '#c0310e',
  A100: '#f7bcd0',
  A200: '#f291b1',
  A400: '#e8487b',
  A700: '#be275c'
}

export const walttiViolet: ColorScale = {
  50: '#eaebf4',
  100: '#cacde5',
  200: '#a8add4',
  300: '#888cc2',
  400: '#6f72b5',
  500: '#5959a8',
  600: '#52519e',
  700: '#4a4792',
  800: '#423d86',
  900: '#362c6f',
  A100: '#d1c4e0',
  A200: '#b39dcc',
  A400: '#8159a8',
  A700: '#59308a'
}

export const yellow: ColorScale = {
  50: '#fffde7',
  100: '#fff9c4',
  200: '#fff59d',
  300: '#fff176',
  400: '#ffee58',
  500: '#ffeb3b',
  600: '#fdd835',
  700: '#fbc02d',
  800: '#f9a825',
  900: '#f57f17',
  A100: '#ffff8d',
  A200: '#ffff00',
  A400: '#ffea00',
  A700: '#ffd600'
}

export const textPrimaryLight = 'rgba(0, 0, 0, 0.87)'
export const textSecondaryLight = 'rgba(0, 0, 0, 0.6)'

export const textPrimaryDark = 'rgba(255, 255, 255, 0.86)'
export const textSecondaryDark = 'rgba(255, 255, 255, 0.7)'

export const colors = {
  error,
  info,
  learn,
  success,
  warning,
  blueGrey,
  cyan,
  deepOrange,
  deepPurple,
  green,
  grey,
  indigo,
  lightBlue,
  lightGreen,
  lime,
  orange,
  pink,
  red,
  teal,
  walttiBrightViolet,
  walttiMidnight,
  walttiOrange,
  walttiViolet,
  yellow,
  textPrimaryLight,
  textSecondaryLight,
  textPrimaryDark,
  textSecondaryDark
} as const
